/**
 * Created by Florin David on 16/06/2017.
 */

import Action, { SET_UPDATE_READY } from 'constants/action-types'

/**
 * Update ready
 */
export default (state = false, action: Action): boolean => {
  switch (action.type) {
    case SET_UPDATE_READY:
      return action.payload
    default:
      return state
  }
}
